import React from "react";
import SiteList from "../../components/SiteList/SiteList";
import NeedsImprovement from "../../components/NeedsImprovement";
import GlobalAverages from "../../components/GlobalAverages";
import BenchmarkAverages from "../../components/BenchmarkAverages";
import data from "../../sites";
import benchmarks from "../../data/benchmarks";
import logo from './logo.png'; // Tell webpack this JS file uses this image

const platforms = { ALL: "All Platforms", WP: "WordPress", DRUPAL: "Drupal" };
const hosts = { ALL: "All Hosts", PANTHEON: "Pantheon", ACQUIA: "Acquia", WPENGINE: "WP Engine" };
const _ = require('lodash');

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      benchmarks: benchmarks,
      manifest: null,
      filteredManifest: null,
      sites: data.sites,
      platform: platforms.ALL,
      hosting: hosts.ALL,
      lcpScores: [],
      inpScores: [],
      clsScores: [],
      averageLCP: 0,
      averageINP: 0,
      averageCLS: 0,
    };
  }

  handleAverageLCPChange = (lcpScore) => {
    this.setState(prevState => ({
      lcpScores: [...prevState.lcpScores, lcpScore]
    }), () => {
      // Calculate the average LCP score
      let averageLCP = this.state.lcpScores.reduce((total, score) => total + score, 0) / this.state.lcpScores.length;

      // Update the averageLCP state
      this.setState({ averageLCP });
    });
  }

  handleAverageINPChange = (inpScore) => {
    this.setState(prevState => ({
      inpScores: [...prevState.inpScores, inpScore]
    }), () => {
      // Calculate the average LCP score
      let averageINP = this.state.inpScores.reduce((total, score) => total + score, 0) / this.state.inpScores.length;

      // Update the averageLCP state
      this.setState({ averageINP });
    });
  }

  handleAverageCLSChange = (clsScore) => {
    this.setState(prevState => ({
      lcpScores: [...prevState.clsScores, clsScore]
    }), () => {
      // Calculate the average LCP score
      let averageCLS = this.state.clsScores.reduce((total, score) => total + score, 0) / this.state.clsScores.length;

      // Update the averageLCP state
      this.setState({ averageCLS });
    });
  }

  componentDidMount = async () => {
    const AWS = require("aws-sdk");
    const s3BucketName = "lighthouse-eos";
    const s3 = new AWS.S3({
      accessKeyId: process.env.REACT_APP_S3_ID,
      secretAccessKey: process.env.REACT_APP_S3_KEY,
      Bucket: s3BucketName,
    });

    // S3 functions
    const getFileFromS3 = (bucket, key) => {
      return new Promise((resolve, reject) => {
        s3.getObject({ Bucket: bucket, Key: key }, (err, data) => {
          if (err) return reject(err);
          try {
            const bodyString = data.Body.toString("utf8");
            resolve(JSON.parse(bodyString));
          } catch (e) {
            reject(err);
          }
        });
      });
    };

    this.setState({
      manifest: await getFileFromS3(s3BucketName, 'manifest_v3.json'),
    });
  };

  updateFilters = (type, value) => {
    this.setState({ [type]: value },
      this.filterData);
  };

  filterData = () => {
    let sitesToList = data.sites;
    let updatedManifest = this.state.manifest;

    let hosting = this.state.hosting;
    let platform = this.state.platform;

    if (platform !== platforms.ALL) {
      sitesToList = sitesToList.filter(
        (site) => site.platform === platform
      );

      updatedManifest = _.flow([
        Object.entries,
        arr => arr.filter(([key, value]) => value.platform === platform),
        Object.fromEntries
      ])(updatedManifest);
    }

    if (hosting !== hosts.ALL) {
      sitesToList = sitesToList.filter(
        (site) => site.hosting === hosting
      );

      updatedManifest = _.flow([
        Object.entries,
        arr => arr.filter(([key, value]) => value.hosting === hosting),
        Object.fromEntries
      ])(updatedManifest);
    }
    
    this.setState({ 
      sites: sitesToList,
      filteredManifest: updatedManifest,
    });
  };

  // Helper functions
  average = (nums) => {
    let numsFiltered = nums.filter(item => item !== 0);
    return numsFiltered.reduce((a, b) => (a + b)) / numsFiltered.length;
  };

  // Scores
  scoreAverages = (manifest) => {

    let scores = {
      "performance": [],
      "best-practices": [],
      "accessibility": [],
      "seo": [],
      "pwa": []
    };

    let scoresBySite = {
      "performance": {},
      "best-practices": {},
      "accessibility": {},
      "seo": {},
      "pwa": {}
    };

    let averages = {
      "performance": 0,
      "best-practices": 0,
      "accessibility": 0,
      "seo": 0,
      "pwa": 0,
    };

    let passingTests = {
      "performance": [],
      "best-practices": [],
      "accessibility": [],
      "seo": [],
      "pwa": []
    };

    let dashboard = {
      "performance": [],
      "best-practices": [],
      "accessibility": [],
      "seo": [],
      "pwa": []
    };

    if (Object.keys(manifest).length <= 0) {
      return {
        averages,
        lowest: [],
        dashboard
      };
    }

    let manifestSites = [];
    for (let site in manifest) {
      if (Object.keys(manifest[site]).length <= 0) {
        continue;
      }
      manifestSites.push(site);
    }

    // Dig through the data to get the scores.
    manifestSites.forEach(site => {
      const timeStampsIdx = Object.keys(manifest[site].tests).sort(function(a, b){return b-a}).slice(0,30);
      timeStampsIdx.forEach(timestamp => {
        const testGroup = manifest[site].tests[timestamp];
        if ( testGroup ) {
          const testTypes  = Object.keys( testGroup );
          testTypes.forEach(test => {
            const testList = manifest[site].tests[timestamp][test];
            if ( testList ) {
              for ( let singleTest in testList ) {

                const individualTest = manifest[site].tests[timestamp][test][singleTest];
                scores["performance"].push(individualTest.scores["performance"]);
                scores["best-practices"].push(individualTest.scores["best-practices"]);
                scores["accessibility"].push(individualTest.scores["accessibility"]);
                scores["seo"].push(individualTest.scores["seo"]);
                scores["pwa"].push(individualTest.scores["pwa"]);

                if (scoresBySite["performance"][site] === undefined) {
                  scoresBySite["performance"][site] = [];
                }
                if (scoresBySite["best-practices"][site] === undefined) {
                  scoresBySite["best-practices"][site] = [];
                }
                if (scoresBySite["accessibility"][site] === undefined) {
                  scoresBySite["accessibility"][site] = [];
                }
                if (scoresBySite["seo"][site] === undefined) {
                  scoresBySite["seo"][site] = [];
                }
                if (scoresBySite["pwa"][site] === undefined) {
                  scoresBySite["pwa"][site] = [];
                }
                scoresBySite["performance"][site].push(individualTest.scores["performance"]);
                scoresBySite["best-practices"][site].push(individualTest.scores["best-practices"]);
                scoresBySite["accessibility"][site].push(individualTest.scores["accessibility"]);
                scoresBySite["seo"][site].push(individualTest.scores["seo"]);
                scoresBySite["pwa"][site].push(individualTest.scores["pwa"]);

              }
            }
          })
        }
      });
    });

    // Figure out the averages.
    averages = {
      "performance": this.average(scores["performance"]),
      "best-practices": this.average(scores["best-practices"]),
      "accessibility": this.average(scores["accessibility"]),
      "seo": this.average(scores["seo"]),
      "pwa": this.average(scores["pwa"]),
    };

    let lowest = {
      "performance" : [],
      "best-practices" : [],
      "accessibility" : [],
      "seo" : [],
      "pwa" : [],
    }

    _.each(scoresBySite,function(sites, metric) {
      _.each(sites,function(scores, site) {
        let siteMetricAvergage = {};
        siteMetricAvergage["site"] = site
        siteMetricAvergage["average"] = this.average(scores);
        lowest[metric].push(siteMetricAvergage);
      }.bind(this));
      lowest[metric] = _.orderBy(lowest[metric], ['average'], ['asc']);
    }.bind(this));

    // Set benchmark percentages.
    for (const category in scores) {
      for (const score in scores[category]) {
        if ( scores[category][score] >= benchmarks[category] ) {
          passingTests[category].push(scores[category][score]);
        }
      }
      dashboard[category] = passingTests[category].length / scores[category].length;
    }

    return {averages,lowest,dashboard};
  };


  render() {
    if (
      this.state.manifest === null || this.state.averageCLS === null || this.state.averageINP === null || this.state.averageLCP === null
    ) {
      return (
        <main className="content-wrapper">
          <p>Loading manifest and calculating core web vitals...</p>
        </main>
      );
    } else {
      const statistics = (this.state.filteredManifest === null) ? this.scoreAverages(this.state.manifest) : this.scoreAverages(this.state.filteredManifest);

      return (
        <main className="dashboard-wrapper">
          <div className="left">
            <header>
              <img src={logo} alt="Logo" />
              <h1>Lighthouse Dashboard</h1>
            </header>
            <div className="filter-wrapper">
              <label>Filter by</label>
              <select
                id="platform"
                className="filter"
                onChange={(e) => {
                  this.updateFilters('platform', e.target.value);
                }}
              >
                {Object.keys(platforms).map((key, index) => (
                  <option key={index} className="menu-item">
                    {platforms[key]}
                  </option>
                ))}
              </select>
              <select
                id="hosting"
                className="filter"
                onChange={(e) => {
                  this.updateFilters('hosting', e.target.value);
                }}
              >
                {Object.keys(hosts).map((key, index) => (
                  <option key={index} className="menu-item">
                    {hosts[key]}
                  </option>
                ))}
              </select>
            </div>
            <div className="stats">
              {/* <CoreWebVitalsAverages
                lcp={this.state.averageLCP}
                inp={this.state.averageINP}
                cls={this.state.averageCLS}
                /> */}
              <GlobalAverages data={statistics.averages}></GlobalAverages>
              <BenchmarkAverages data={statistics.dashboard}></BenchmarkAverages>
            </div>
            <NeedsImprovement data={statistics.lowest}></NeedsImprovement>
          </div>
          <div className="right">
            <div className="site-list">
              {this.state.sites.map((site) => (
                <SiteList
                  name={site.name}
                  id={site.id}
                  key={site.id}
                  url={site.urls[0].url}
                  site={site}
                  platform={site.platform}
                  hosting={site.hosting}
                  manifest={this.state.manifest[site.id].tests}
                  //onAverageLCPChange={this.handleAverageLCPChange}
                  //onAverageINPChange={this.handleAverageINPChange}
                  //onAverageCLSChange={this.handleAverageCLSChange}
                />
              ))}
            </div>
          </div>
        </main>
      );
    }
  }
}

export default Dashboard;
